import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { PaymentHistory } from '../../../../../core/models/payment.model';
import { toPng } from 'html-to-image';
import { LanguageService } from '../../../../../core/services/language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-receipt-page',
  imports: [CommonModule, FormsModule],
  templateUrl: './receipt-page.component.html',
  styleUrls: ['./receipt-page.component.css'],
})
export class ReceiptPageComponent {
  @ViewChild('receiptRef', { static: false }) receiptRef!: ElementRef;
  selectedPayment: PaymentHistory | null = null;
  token: string = '';
  uid: string = '';
  currentLang: string = 'TH';
  sub!: Subscription;

  constructor(
    private cookieService: CookieService,
    private toast: ToastNotifService,
    private toastr: ToastrService,
    private router: Router,
    private http: HttpClient,
    private languageService: LanguageService
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras.state as {
      selectedPayment: PaymentHistory;
    };
    if (state) {
      this.selectedPayment = state.selectedPayment;
    } else {
      console.log('No data');
    }
  }

  ngOnInit() { }

  /*#################################################### Function ################################################*/

  /**
   * Captures receipt container as image using html-to-image (native SVG ForeignObject engine).
   * This completely avoids CSS parser errors like oklch in Tailwind v4.
   */
  downloadReceiptImage(): void {
    const element = this.receiptRef?.nativeElement;
    if (!element) {
      console.error('Receipt element not found');
      return;
    }

    toPng(element, { pixelRatio: 2, cacheBust: true, fontEmbedCSS: '' })
      .then((dataUrl) => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

        if (isIOS) {
          const newTab = window.open();
          if (newTab) {
            newTab.document.body.innerHTML = `<img src="${dataUrl}" style="width:100%;">`;
          }
        } else {
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = `receipt_${this.selectedPayment?.receiptId || 'download'}.png`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch((error) => {
        console.error('Error capturing receipt image:', error);
        this.toastr.error(
          this.currentLang === 'TH' ? 'ไม่สามารถบันทึกรูปภาพได้' : 'Failed to save image',
          this.currentLang === 'TH' ? 'ผิดพลาด' : 'Error'
        );
      });
  }

  /**
   * Navigates back to previous page.
   */
  goBack() {
    window.history.back();
  }
}
